/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MarkInvoiceSettlementResult
 */
export interface MarkInvoiceSettlementResult {
  /**
   *
   * @type {string}
   * @memberof MarkInvoiceSettlementResult
   */
  customerInvoiceId: string;
  /**
   *
   * @type {string}
   * @memberof MarkInvoiceSettlementResult
   */
  invoiceIdentifier?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof MarkInvoiceSettlementResult
   */
  success: boolean;
  /**
   *
   * @type {string}
   * @memberof MarkInvoiceSettlementResult
   */
  error?: string | null;
}

/**
 * Check if a given object implements the MarkInvoiceSettlementResult interface.
 */
export function instanceOfMarkInvoiceSettlementResult(
  value: object,
): value is MarkInvoiceSettlementResult {
  if (
    !("customerInvoiceId" in value) ||
    value["customerInvoiceId"] === undefined
  )
    return false;
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function MarkInvoiceSettlementResultFromJSON(
  json: any,
): MarkInvoiceSettlementResult {
  return MarkInvoiceSettlementResultFromJSONTyped(json, false);
}

export function MarkInvoiceSettlementResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MarkInvoiceSettlementResult {
  if (json == null) {
    return json;
  }
  return {
    customerInvoiceId: json["customerInvoiceId"],
    invoiceIdentifier:
      json["invoiceIdentifier"] == null ? undefined : json["invoiceIdentifier"],
    success: json["success"],
    error: json["error"] == null ? undefined : json["error"],
  };
}

export function MarkInvoiceSettlementResultToJSON(
  json: any,
): MarkInvoiceSettlementResult {
  return MarkInvoiceSettlementResultToJSONTyped(json, false);
}

export function MarkInvoiceSettlementResultToJSONTyped(
  value?: MarkInvoiceSettlementResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    customerInvoiceId: value["customerInvoiceId"],
    invoiceIdentifier: value["invoiceIdentifier"],
    success: value["success"],
    error: value["error"],
  };
}
